<template>
	<div class="container-fluid text-center">

		<h1>{{ message }}</h1>

		<template v-if="alreadyRegisteredError">
			<p>Your account is already registered and active. You should go <router-link to="/login">log in</router-link>.</p>
		</template>

		<p v-if="details" v-html="stripInlineEventHandlers(details)"></p>
	</div>
</template>

<script>
import Field from "../../components/Field"

export default {

	name: 'RegisterInvite',
	components: {
		Field
	},
	data() {
		return {
			message: "Please wait...",
			details: false,
			alreadyRegisteredError: false,
			inviteCompany: {
				company_name: ""
			},
			email: "",
			payload: {}
		}
	},
	methods: {
		validateToken() {
			let vm = this

			this.getJSON("User/find-invited",{token: this.$route.params.token}).then(response => {

				if (response.success) {
					//login user

					vm.$store.accountSetupMode = true

					localStorage.apiKey = response.data.api_key
					localStorage.sessionToken = JSON.stringify(response.data.session_token)

					vm.$bus.$emit("updateUserPermissions",response.data)

					vm.$bus.$emit("loginStatus",true)

					vm.$nextTick(() => {
						vm.$router.push("/employee/"+vm.$store.userDetails.slug+"/profile")
					})

				}
				else {
					if (vm.message == 'Token not valid') {
						vm.details = "This token doesn't seem to be valid. You have either reached this page by accident, or there has been a server error."
					}
					else if (vm.message == 'Registration already completed') {
						vm.alreadyRegisteredError = true
					}
					else {
						vm.alreadyRegisteredError = false
					}

					if (response && "errors" in response) {
						vm.message = response.errors[0]
						vm.details = "You have probably reached this page by mistake. <a href='/login'>Log in</a>."
					}
					
				}
			})
		}
	},
	created() {
		this.validateToken()
	}

}
</script>

<style type="text/css" scoped>
	form {
		margin: auto;
		max-width: 700px;
		padding: 20px;
	}
</style>